import React from "react";
// import "./AcadamicCalender.css";
// import Tabs from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
// import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";



// import { styled } from "@mui/material/styles";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell, { tableCellClasses } from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import Paper from "@mui/material/Paper";
import AdministrationMembers from "./Members";
import AdministrationMinutes from "./Minutes";

const AdminstrationGovernigBody = () => {
  const [valueTab, setValueTab] = React.useState("one");
  const [value, setValue] = React.useState("1");
  const handleChangeTabs = (event, newValue) => {
    setValueTab(newValue);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div style={{ display: "flex", justifyContent: "space-around" }}>
      {/* {valueTab === "members" && <AdministrationMembers />} */}
      

      {/* {valueTab === "minutes" && <AdministrationMinutes />} */}
      




      <Box sx={{ width: "100%", typography: "body1", textAlign: "center" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              centered
              onChange={handleChange}
              aria-label="lab API tabs example"
            >
              <Tab
                sx={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  color: "rgb(37, 31, 31)",
                }}
                label="ACADEMIC BODY MEMBERS"
                value="1"
              />
              <Tab
                sx={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  color: "rgb(37, 31, 31)",
                }}
                label="ACADEMIC BODY MINUTES"
                value="2"
              />
             
              
            </TabList>
          </Box>
          <TabPanel value="1">
            <h3>ACADEMIC BODY MEMBERS</h3>
            <AdministrationMembers />

          
          </TabPanel>
          <TabPanel value="2">
            <h3>ACADEMIC BODY MINUTES</h3>
            <AdministrationMinutes />
          </TabPanel>

        </TabContext>
      </Box>
    </div>
  );
};

export default AdminstrationGovernigBody;
{
  /* <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "orange",
          marginBottom: "20px",
        }}
      >
        <Tabs
          value={valueTab}
          onChange={handleChangeTabs}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs example"
        >
          <Tab
            sx={{ color: "black", fontWeight: "bold" }}
            value="members"
            label="ACADEMIC BODY MEMBERS"
          />
          <Tab
            sx={{ color: "black", fontWeight: "bold" }}
            value="minutes"
            label="ACADEMIC BODY MINUTES"
          />
        </Tabs>
      </Box> */
}
